import { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Avatar, Button, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { logOut } from "../../../redux/slices/authenticationSlice";
import { useAuth } from "../../../hooks/useAuth";
import colaLogo from "../../../assets/CC-logo.png";

function TopBarAdmin() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const location = useLocation();
  const [anchorElUser, setAnchorElUser] = useState();
  const [anchorElNav, setAnchorElNav] = useState();
  const [currentLocation, setCurrentLocation] = useState();

  const userMe = useSelector((state) => state.user.userMe);
  const settings = [t("navigation.logOut")];
  const pages = [
    { id: 0, name: t("navigation.navUsers"), path: "/admin/users" },
    { id: 1, name: t("navigation.navSettings"), path: "/admin/settings" },
    { id: 2, name: t("navigation.navGifts"), path: "/admin/gifts" },
    {
      id: 3,
      name: t("navigation.navReceipts"),
      path: "/admin/receipts-processing",
    },
    {
      id: 4,
      name: t("navigation.reports"),
      path: "/admin/reports",
    },
    {
      id: 5,
      name: t("navigation.sendingGifts"),
      path: "/admin/sending-gifts",
    },
  ];

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (event) => {
    if (event.target.textContent === "Log out") {
      dispatch(logOut()).then(() => {
        logout();
      });
    }
    // if (event.target.textContent === "Profil") {
    //   dispatch(setIsBottomBarVisible(false));
    //   navigate("/home/profile");
    // }
    setAnchorElUser(null);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
    if (event.target.textContent === "Korisnici") {
      navigate("/admin/users");
    } else if (event.target.textContent === "Podešavanja") {
      navigate("/admin/settings");
    } else if (event.target.textContent === "Pokloni") {
      navigate("/admin/gifts");
    } else if (event.target.textContent === "Obrada računa") {
      navigate("/admin/receipts-processing");
    } else if (event.target.textContent === "Izveštaji") {
      navigate("/admin/reports");
    } else if (event.target.textContent === "Slanje poklona") {
      navigate("/admin/sending-gifts");
    }
  };
  useEffect(() => {
    setCurrentLocation(location?.pathname);
  }, [location]);

  return (
    <AppBar
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        // backgroundColor: "#F40002",
      }}
    >
      <Container maxWidth="xxl">
        <Toolbar disableGutters>
          <Stack
            marginRight={1}
            sx={{
              backgroundColor: "white",
              padding: "1px 4px",
              borderRadius: "5px",
            }}
          >
            <img src={colaLogo} alt="logo" width="40px" />
          </Stack>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {t("companyName")} ADMIN
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.id} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {t("companyName")}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                variant={currentLocation === page.path ? "contained" : "text"}
                color="error"
                key={page.id}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Stack display="flex" direction="row" alignItems="center">
              <Typography component="div" variant="body" marginRight="8px">
                {userMe?.username}
              </Typography>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userMe?.username} src={userMe?.avatar?._url} />
              </IconButton>
            </Stack>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default TopBarAdmin;
